window.onbeforeunload = function() {};
window.onunload = function() {};
window.ontouchstart = function() {};
window.addEventListener('touchstart', function() {}, true);
window.addEventListener('touchstart', function() {}, false);
document.ontouchstart = function() {};
document.addEventListener('touchstart', function() {}, true);
document.addEventListener('touchstart', function() {}, false);

var movefun = function( event ){
  event.preventDefault();
}
// スクロール停止の処理
window.addEventListener( 'touchmove' , movefun , { passive: false } );
// スクロール停止することを停止する処理
window.removeEventListener( 'touchmove' , movefun, { passive: false } );

/*//////////////////////////////////////////////////////リサイズ*/
var winW, winH
var h_animef = true;
var mX = -50;
var mY = -50;
window.onmousemove = handleMouseMove;
function handleMouseMove(event) {
  event = event || window.event; // IE対応
  mX = event.clientX;
  mY = event.clientY;
}
function resize() {
  winW = $(window).width()
  winH = $(window).height()
}

var h_animef = true;

$(function(){
  $(".drawer").drawer();

  $('.root_category').each(function(i){
    $(this).addClass('sd').attr('href', 'javascript:void(0);').append('<div></div>');
  });

  var myScroll;

  window.onload = function() {
    myScroll = new IScroll('.drawer-nav', {
      mouseWheel: true,
      click: false
    });

    $(document).on('click', '.drawer-menu .sd,.drawer-hamburger', function () {
      setTimeout(function(){
        myScroll.refresh();
      },400);
    });
  };

  $(document).on('click touchstart', '.drawer-close .drawer-hamburger', function () {
    $('.drawer-menu .sd').removeClass('on').next().slideUp();
    return false;
  });

  $(document).on('click', '.drawer-menu .sd', function () {
    $(this).toggleClass('on').next().slideToggle(300);
    $('.drawer-menu .sd').not($(this)).removeClass('on').next().slideUp();
    return false;
  });

  $(document).on('click', '#gFooter .sd', function () {
    $(this).toggleClass('on').next().slideToggle(300);
    $('#gFooter .sd').not($(this)).removeClass('on').next().slideUp();
    return false;
  });
    $(".subMenu").each(function(i){
      $(this).find('a').eq(0).remove()
    });
  $(window).on('load', function(){
    $("#loader").fadeOut(600);

    $('.product_title h1 .char').each(function() {
      if($(this).size() == 0){
        $(this).addClass('aaaa');
      }
    });
  });


  wp_set()
  resize()
  pjax_barba()

  $(window).load(function(){
    resize()
  })
  $(window).resize(function(){
    resize()
  })

  setTimeout(function(){
    header_op()
  },350)});


var pc_op = false;
function header_op(){
  TweenLite.to($("#gHeader"),1,{opacity:1})
  if(!$("body").hasClass("sm")&&!$("body").hasClass("md")){
    pc_op = true;
    $("#gHeader li").each(function(i){
      $(this).find(".char").each(function(t){
        TweenLite.to($(this),0,{y:30})
        TweenLite.to($(this),0.6,{y:0,delay:(t*0.01)+(i*0.06),ease:Power3.easeOut})
      })
    })
  }
}

function header_anime(){
  $("#g_menu").css("display","block")
  $("#gHeader #g_nav li a .char").css({transform:'translateY(30px)'})
  $("#gHeader li").each(function(i){
    $(this).find(".char").each(function(t){
      TweenLite.to($(this),0,{y:30})
      TweenLite.to($(this),0.6,{y:0,delay:(t*0.01)+(i*0.06),ease:Power3.easeOut})
    })
  })
}

function header_anime_out(){
  $("#g_menu").css("display","none")
  $("#gHeader #g_nav li").each(function(i){
    $(this).find(".char").each(function(t){
      TweenLite.to($(this),0.6,{y:-30,delay:(t*0.01)+(i*0.06),ease:Power3.easeOut})
    })
  })
}

/*pjax処理*/
function pjax_barba(){
  int_index()
  op()
  TweenLite.to($("#gHeader"),0,{top:0,ease:Power3.easeOut})

  //video_index()
  Barba.Pjax.init();
  Barba.Prefetch.init();

  // headタグ内の書き換え
  Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container, newPageRawHTML) {

    var head = document.head;
    var newPageRawHead = newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    var newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    var removeHeadTags = [
    "meta[name='description']",
    "meta[property^='og']",
    "meta[name^='twitter']",
    "link[rel='canonical']"
    ].join(',');
    var headTags = head.querySelectorAll(removeHeadTags)
    for(var i = 0; i < headTags.length; i++ ){
      head.removeChild(headTags[i]);
    }
    var newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for(var i = 0; i < newHeadTags.length; i++ ){
      head.appendChild(newHeadTags[i]);
    }
  });

  // Googleアナリティクスに情報を送る
  Barba.Dispatcher.on('initStateChange', function() {
    if (typeof ga === 'function') {
      ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search);
    }
  });

  Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
  Barba.Pjax.preventCheck = function(evt, element) {
    if(element){
      if (!element.getAttribute('href')) {
        return false;
      }
      
      // アンカーリンクであり同一ページでなければbarbaを有効に
      var url = location.protocol + '//' + location.host + location.pathname;
      var extract_hash = element.href.replace(/#.*$/,"");
      if (element.href.startsWith(location.protocol + '//' + location.host)) {
        if (element.href.indexOf('#') > -1 && extract_hash != url ){
          return true;
        }
      }
      
      // 該当クラスに属していればBarbaを無効に
      var ignoreClasses = ['ab-item','custom-no-barba'];
      for (var i = 0; i < ignoreClasses.length; i++) {
        if (element.classList.contains(ignoreClasses[i])) {
          return false;
        }
      }
      if (!Barba.Pjax.originalPreventCheck(evt, element)) {
        return false;
      }
      return true;
    }
  };

  var home_fv = true;

  // ページごとの処理
  var HomeTransition = Barba.BaseView.extend({
    namespace: 'home_index',
    onEnter:function(){
      TweenLite.to($(".banner_bg"),0,{scale:1.2})
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      $(".product .product_info a").each(function(){
        var surl = $(this).attr("href")
        $(this).attr("href",surl+"?index")
      })

      $(".product_intro").each(function(){
        if($(this).hasClass("line")){
          $(this).parent().parent("li").addClass("line")
        }
      })
      TweenLite.to($(".banner_bg"),8,{scale:1})
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  HomeTransition.init();

  var AboutTransition = Barba.BaseView.extend({
    namespace: 'about_index',
    onEnter:function(){
      TweenLite.to($(".banner_bg"),0,{scale:1.2})
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      TweenLite.to($(".banner_bg"),8,{scale:1})
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  AboutTransition.init();

  var colleListTransition = Barba.BaseView.extend({
    namespace: 'list_index',
    onEnter:function(){
      TweenLite.to($(".banner_bg"),0,{scale:1.1})
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      TweenLite.to($(".banner_bg"),6,{scale:1})
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  colleListTransition.init();

  var collectionTransition = Barba.BaseView.extend({
    namespace: 'collection_index',
    onEnter:function(){
      TweenLite.to($(".banner_bg"),0,{scale:1.1})
      var sections = new theme.Sections();
      sections.register('collection-template', theme.Filters);
      TweenLite.to($(".product_show p"),0,{scale:1.2})
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      TweenLite.to($(".banner_bg"),6,{scale:1})
      TweenLite.to($(".product_show p"),8,{scale:1})
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  collectionTransition.init();

  var ProductDetailTransition = Barba.BaseView.extend({
    namespace: 'product_detail_index',
    onEnter:function(){
    },
    onEnterCompleted:function(){
      $(".slick").not('.slick-initialized').slick({
        dots: true,
        speed: 300,
        infinite: true,
        autoplay: false,
        fade: true,
        cssEase: 'linear',
        prevArrow: '<button class="prev"><div></div></button>',
        nextArrow: '<button class="next"><div></div></button>'
      })

      var num = 0;
      $('.detail_pic .product_num').html("01<span>/<i>0"+$(".detail_pic .product_num .slick-slide").length+"</i></span>");
      $('button.prev').on('click', function() {
        let num = $(".slick-current").index()+1;
        if(num<10){
          $('.detail_pic .product_num').html("0"+num+"<span>/<i>0"+$(".slick-slide").length+"</i></span>");
        }else{
          $('.detail_pic .product_num').html(num+"<span>/<i>"+$(".slick-slide").length+"</i></span>");
        }
      })
      $('button.next').on('click', function() {
        let num = $(".slick-current").index()+1;
        if(num<10){
          $('.product_detail .product_num').html("0"+num+"<span>/<i>0"+$(".slick-slide").length+"</i></span>");
        }else{
          $('.product_detail .product_num').html(num+"<span>/<i>"+$(".slick-slide").length+"</i></span>");
        }
      })
      $('.detail_pic .product_num').html("01<span>/<i>0"+$(".slick-slide").length+"</i></span>");

      $('.slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        let num = nextSlide+1;
        if(num<10){
          $('.detail_pic .product_num').html("0"+num+"<span>/<i>0"+$(".slick-slide").length+"</i></span>");
        }else{
          $('.detail_pic .product_num').html(num+"<span>/<i>"+$(".slick-slide").length+"</i></span>");
        }
      });
      if($(".slick-slide").length+1<10){
        $('.detail_pic .product_num').html("01<span>/<i>0"+$(".slick-slide").length+"</i></span>");
      }else{
        $('.detail_pic .product_num').html("01<span>/<i>"+$(".slick-slide").length+"</i></span>");
      }
      $("#loader").fadeOut(600);
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
      $("header,footer").fadeIn(1000)
    }
  });
  ProductDetailTransition.init();

  var NewsTransition = Barba.BaseView.extend({
    namespace: 'news_index',
    onEnter:function(){
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      $(window).on('load resize', function(){
      var winH = $(window).innerHeight(),
          mainH = $('#gHeader').outerHeight(),
          footH = $('#gFooter').outerHeight(),
          barH = winH - mainH - footH - 45;
      if(winH>mainH){
        $('#barba-wrapper').css('min-height',barH);
        $("#gFooter").addClass("on")
      }
      });
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  NewsTransition.init();

  var ShopTransition = Barba.BaseView.extend({
    namespace: 'shop_index',
    onEnter:function(){
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      $(window).on('load resize', function(){
      var winH = $(window).innerHeight(),
          mainH = $('#gHeader').outerHeight(),
          footH = $('#gFooter').outerHeight(),
          barH = winH - mainH - footH - 45;
      if(winH>mainH){
        $('#barba-wrapper').css('min-height',barH);
        $("#gFooter").addClass("on")
      }
      });
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  ShopTransition.init();

  var OtherTransition = Barba.BaseView.extend({
    namespace: 'other_index',
    onEnter:function(){
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      $(window).on('load resize', function(){
      var winH = $(window).innerHeight(),
          mainH = $('#gHeader').outerHeight(),
          footH = $('#gFooter').outerHeight(),
          barH = winH - mainH - footH - 45;
      if(winH>mainH){
        $('#barba-wrapper').css('min-height',barH);
        $("#gFooter").addClass("on")
      }
      });
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  OtherTransition.init();

  var FormTransition = Barba.BaseView.extend({
    namespace: 'form_index',
    onEnter:function(){
      "use strict";
      $('input[type="submit"]').prop("disabled", true).fadeTo(0,0.5);
      $('#privacyCheck').click(function(){
        if( $(this).prop("checked") ){
          $('input[type="submit"]').prop("disabled", false).fadeTo(0.5,1);
        } else {
          $('input[type="submit"]').prop("disabled", true).fadeTo(0.5,0.5);
        }
      });
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      $(window).on('load resize', function(){
      var winH = $(window).innerHeight(),
          mainH = $('#gHeader').outerHeight(),
          footH = $('#gFooter').outerHeight(),
          barH = winH - mainH - footH - 45;
      if(winH>mainH){
        $('#barba-wrapper').css('min-height',barH);
        $("#gFooter").addClass("on")
      }
      });
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  FormTransition.init();

  var OtherTransition = Barba.BaseView.extend({
    namespace: 'other_index',
    onEnter:function(){
    },
    onEnterCompleted:function(){
      $("#loader").fadeOut(600);
      $(window).on('load resize', function(){
      var winH = $(window).innerHeight(),
          mainH = $('#gHeader').outerHeight(),
          footH = $('#gFooter').outerHeight(),
          barH = winH - mainH - footH - 45;
      if(winH>mainH){
        $('#barba-wrapper').css('min-height',barH);
        $("#gFooter").addClass("on")
      }
      });
    },
    onLeave: function() {
      $("#loader").fadeIn(300);
    },
    onLeaveCompleted: function() {
    }
  });
  OtherTransition.init();

  var ua = navigator.userAgent.toLowerCase();
  var isWindows = (ua.indexOf('windows') > -1) && !((ua.indexOf('mac') > -1) && (ua.indexOf('os') > -1)) && !((ua.indexOf('iphone') > -1) || (ua.indexOf('ipad') > -1));
      
    $(".slick").not('.slick-initialized').slick({
      dots: true,
      speed: 300,
      infinite: true,
      autoplay: false,
      fade: true,
      cssEase: 'linear',
      prevArrow: '<button class="prev"><div></div></button>',
      nextArrow: '<button class="next"><div></div></button>'
    })

    var num = 0;
    $('.detail_pic .product_num').html("01<span>/<i>0"+$(".detail_pic .product_num .slick-slide").length+"</i></span>");
    $('button.prev').on('click', function() {
      let num = $(".slick-current").index()+1;
      if(num<10){
        $('.detail_pic .product_num').html("0"+num+"<span>/<i>0"+$(".slick-slide").length+"</i></span>");
      }else{
        $('.detail_pic .product_num').html(num+"<span>/<i>"+$(".slick-slide").length+"</i></span>");
      }
    })
    $('button.next').on('click', function() {
      let num = $(".slick-current").index()+1;
      if(num<10){
        $('.product_detail .product_num').html("0"+num+"<span>/<i>0"+$(".slick-slide").length+"</i></span>");
      }else{
        $('.product_detail .product_num').html(num+"<span>/<i>"+$(".slick-slide").length+"</i></span>");
      }
    })
    $('.detail_pic .product_num').html("01<span>/<i>0"+$(".slick-slide").length+"</i></span>");

    $('.slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      let num = nextSlide+1;
      if(num<10){
        $('.detail_pic .product_num').html("0"+num+"<span>/<i>0"+$(".slick-slide").length+"</i></span>");
      }else{
        $('.detail_pic .product_num').html(num+"<span>/<i>"+$(".slick-slide").length+"</i></span>");
      }
    });
    if($(".slick-slide").length+1<10){
      $('.detail_pic .product_num').html("01<span>/<i>0"+$(".slick-slide").length+"</i></span>");
    }else{
      $('.detail_pic .product_num').html("01<span>/<i>"+$(".slick-slide").length+"</i></span>");
    }


  TweenLite.to($("h1.-roboto,h2.-roboto"),0,{y:20,opacity:0})
  TweenLite.to($("h1.-roboto,h2.-roboto"),1,{y:0,opacity:1,delay:2.5})
  setTimeout(function(){$("h1.-roboto,h2.-roboto").parents("div").removeClass("on")},1000)
  setTimeout(function(){$("h1.-roboto,h2.-roboto").parents("div").addClass("on")},2500)
  var PageTransition = Barba.BaseTransition.extend({
    start: function() {
      $(".navi_list").find("a").each(function(i){
        $(this).removeClass("now")
      })
      int_index()

      Promise
      .all([this.newContainerLoading, this.fadeOut()])
      .then(this.fadeIn.bind(this));
    },
    fadeOut: function() {
      if(winW<769){
        setTimeout(function(){$("#gHeader").removeClass('open')},800)
        header_anime_out()
      }
      /*TweenLite.to($("#cover_con"),0.6,{width:"100%",onComplete:function(){
        $("#cover_con").css({left:"auto",right:0})
      }})*/
      //TweenLite.to($(".load2"),0.3,{opacity:0.5})
      //this.oldContainerは古いコンテナのHTMLElementです。この場合はアニメーションでフェードアウトさせている。
      return $(this.oldContainer).animate({ opacity: 0 },300).promise();
    },
    fadeIn: function() {
      wp_set()
      $("h4.-roboto").parent("div").removeClass("on")
      TweenLite.to($("h4.-roboto"),0,{y:20,opacity:0})
      TweenLite.to($("h4.-roboto"),1,{y:0,opacity:1,delay:1})
      setTimeout(function(){$("h4.-roboto").parents("div").removeClass("on")},50)
      setTimeout(function(){$("h4.-roboto").parents("div").addClass("on")},1200)
      $("html,body").scrollTop(0)

      op()
      var _this = this;
      var $el = $(this.newContainer);
      $(this.oldContainer).hide();
      $el.css({
        visibility : 'visible',
        opacity : 0
      });
      $el.animate({ opacity: 1 }, 150, function() {
        _this.done();
      });
    }
  });

  Barba.Pjax.getTransition = function() {
    return PageTransition;
  };

  Barba.BaseView.init()
  Barba.Pjax.start();
}

function int_index(){
  if(location.href.indexOf("/pages/about")>= 0){
    $(".navi_list li").find("a").each(function(i){
      $(this).find('a').removeClass('now');
    });
    $(".navi_list li").eq(0).find("a").addClass("now");
  }
  if(location.href.indexOf("/collections")>= 0 && location.href.indexOf("/fragrance")<0){
    $(".navi_list li").find("a").each(function(i){
      $(this).find('a').removeClass('now');
    });
    $(".navi_list li").eq(1).find("a").addClass("now");
  }
  if(location.href.indexOf("/fragrance")>= 0){
    $(".navi_list li").find("a").each(function(i){
      $(this).find('a').removeClass('now');
    });
    $(".navi_list li").eq(2).find("a").addClass("now");
  }
  if(location.href.indexOf("/blogs/news")>= 0){
    $(".navi_list li").find("a").each(function(i){
      $(this).find('a').removeClass('now');
    });
    $(".navi_list li").eq(3).find("a").addClass("now");
  }
  if(location.href.indexOf("/pages/shop-list")>= 0){
    $(".navi_list li").find("a").each(function(i){
      $(this).find('a').removeClass('now');
    });
    $(".navi_list li").eq(4).find("a").addClass("now");
  }
}
function op(){
  scroll_anime()
}

var scTop
function scroll_anime(){
  $("body").height(winH)
  var scTop_a
  TweenLite.to($("#gFooter"),0.6,{y:0})
  $("body").css({height:"auto"})
  window.onscroll = function() {
   if (navigator.userAgent.toLowerCase().match(/safari/)) {
    		// Webkit系（Safari, Chrome, iOS）、IE5はbody要素
    		scTop = documentElement = $(document).scrollTop()
     } else {
    		// IE（6以上）、Firefox、Operaはhtml要素
    		scTop =   documentElement = $(window).scrollTop();
     }
     var pr = ((scTop)/($("html").height()-winH))*100;

     if(scTop>80){
      $("#gHeader, .btn_menu").addClass("sc")
    }else{
      $("#gHeader, .btn_menu").removeClass("sc")
    }
    $(".h_scrollbar_in").css({width:pr+'%'})

    if(winW>1150){
      if(scTop>$("body").height()-(winH)){
        $("#gFooter").addClass("on")
      }else{
        $("#gFooter").removeClass("on")
      }
    }
  }

  var controller = new ScrollMagic.Controller();
  $(".fI").each(function(i){
    TweenMax.to($(this), 0, {opacity: 0});
    var tween = TweenMax.to($(this), 0.4, {opacity: 1,delay:0.2});
    var $title_font = $(this)
  	var scene = new ScrollMagic.Scene({reverse:false,triggerElement: $(this).get(0),offset:(-winH/2)}) // トリガー要素、終了距離（px）
    .setTween(tween)
    .setClassToggle($(this).get(0),"on")
    .addTo(controller);
  })

  $(".fIU").each(function(i){
    TweenMax.to($(this), 0, {opacity: 0,y:30});
    var tween = TweenMax.to($(this), 0.4, {opacity: 1,y:0,delay:0.2});
    var $title_font = $(this)
  	var scene = new ScrollMagic.Scene({reverse:false,triggerElement: $(this).get(0),offset:(-winH/2)}) // トリガー要素、終了距離（px）
    .setTween(tween)
    .setClassToggle($(this).get(0),"on")
    .addTo(controller);
  })

  $(".product_pic").each(function(i){
    $(this).find("div").css("overflow","hidden")
    $(this).find("img").css({"width":$(this).width()})
    $(this).find("div").css({"width":$(this).width()})

    var wd = $(this).width()
    TweenMax.to($(this).find("div"), 0, {y:30,width:0});
    var tween = TweenMax.to($(this).find("div"), 1, {y:0,ease:Power3.easeInOut,width:wd});
    var $title_font = $(this)
  	var scene = new ScrollMagic.Scene({reverse:false,triggerElement: $(this).get(0),offset:(-winH/2)}) // トリガー要素、終了距離（px）
    .setTween(tween)
    .setClassToggle($(this).get(0),"on")
    .addTo(controller);
  })

  $(".lT").lettering('words').children('span').lettering();
  $(".lT").each(function(i){
    var tween = TweenMax.to($(this), 1, {delay:0.3,opacity: 1,y:0});
    var $title_font = $(this)
    $title_font.find(".char").each(function(t){
      TweenLite.to($(this),0,{y:30,opacity:0})
    })
    var scene = new ScrollMagic.Scene({reverse:false,triggerElement: $(this).get(0),offset:(-winH/2)}) // トリガー要素、終了距離（px）
    .on("enter", function (event) {
     $title_font.find(".char").each(function(t){
       TweenLite.to($(this),0,{y:30,opacity:0})
       TweenLite.to($(this),0.6,{y:0,opacity:1,delay:0.1+(t*0.06)+(i*0.06),ease:Power3.easeOut})
     })
  })
    .addTo(controller);
  })
}

$(window).on('resize', function(){
  $(".product_pic").each(function(i){
    $(this).find("div").css("overflow","hidden")
    $(this).find("img").css({"width":$(this).width()})
    $(this).find("div").css({"width":$(this).width()})
  })
});

function wp_set(){
  $(".product").each(function(t){
    var $prod = $(this)
    var it = t
    $(this).find(".product_info .product_num").each(function(i){
      console.log(i)
      if(i+1<10){
        $(this).html("0"+(1+i)+"<span>/<i>"+($prod.find(".product_num").length)+"</i></span>");
      }else{
        $(this).html((1+i)+"<span>/<i>"+($prod.find(".product_num").length)+"</i></span>");
      }
    })
  })
}

//like a cover
objectFitImages()

//menu
$('.drop > a').mouseenter(function(){
  $(this).addClass('on');
  $(this).find('.subMenu').css('top', '100px');
}).mouseleave(function(){
  $(this).removeClass('on');
  $('#menuNav').removeClass('hidOn');
  var menuPhHW = $(this).find('.drop').height();
  $(this).find('.subMenu').css('top', '100px');
});

